import React from "react";
import Card from "../../components/Card";
import List, { ListItem } from "../../components/List";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

const Thanks = () => {
  return (
    <React.Fragment>
      <ScrollToTop />
      <Card title="You’re signed up" removeTopPadding>
        <p>Thanks for choosing Juno. Here’s what happens next:</p>
        <List number>
          <ListItem>We’ll send you a welcome email with a short form to fill in.</ListItem>
          <ListItem>
            Once you’ve filled it in, you can complete your ID checks online and follow your case on your Juno
            dashboard.
          </ListItem>
        </List>
      </Card>
      <Image src={imageOfficeWorking} fullWidth />
    </React.Fragment>
  );
};

export default Thanks;
